import MuiInputBase from '@material-ui/core/InputBase';

export default MuiInputBase;
